import type { AllHTMLAttributes } from "react";
import { createContext, useContext } from "react";

import { ATTR_SERVICE_NAME, Resource } from "@honeycomb/telemetry";

import { createUserTelemetry } from "./user-telemetry";
import { createWebVitalMeters } from "./web-reporter";

const notReady = () => {
  console.warn("telemetry service not ready");
};

export type TelemetryTracingProviderProps = {
  apiKey: string;
  exporterUrl: string;
  serviceName: string;
} & AllHTMLAttributes<HTMLElement>;
export type TelemetryTracing = {
  track: () => void;
};

export const TelemetryTracingContext = createContext<TelemetryTracing>({
  track: notReady,
});

export const useTelemetryTracingContext = () => useContext(TelemetryTracingContext);

export const TelemetryTracingProvider = ({
  children,
  apiKey,
  exporterUrl,
  serviceName,
}: TelemetryTracingProviderProps) => {
  if (!apiKey || !exporterUrl || !serviceName) {
    console.warn("unable to initialize OTEL: missing config", { apiKey, exporterUrl, serviceName });
    return <>{children}</>;
  }

  const resource = new Resource({
    [ATTR_SERVICE_NAME]: serviceName, // TODO ::: replace with ENV_VAR
  });
  const userTelemetry = createUserTelemetry(resource, apiKey, exporterUrl);

  createWebVitalMeters(resource, apiKey, exporterUrl);

  return <TelemetryTracingContext.Provider value={userTelemetry}>{children}</TelemetryTracingContext.Provider>;
};
